import React from 'react'
import classNames from 'classnames'
import styles from '../mainNavBar.module.scss'

interface BurgerMenuProps {
  isOpen: boolean
}

const BurgerMenu: React.FC<BurgerMenuProps> = ({ isOpen }) => {
  return (
    <div
      className={classNames(styles.burger, { [styles.open]: isOpen })}
      role='presentation'
      aria-hidden='true'
    >
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default BurgerMenu
